import moment from 'moment-timezone';
import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class PosTimeService {
	private strTimeZone = 5.5;
	private timezoneName = '';
	private currentTime!: Date;
	private clockTimeInMillis = 0;
	private intervalID!: ReturnType<typeof setInterval>;
	private fulltimezoneName = '';

	updateClock() {
		this.intervalID = setInterval(() => {
			this.clockTimeInMillis = this.clockTimeInMillis + 1000;
			this.currentTime.setTime(this.clockTimeInMillis);
		}, 1000);
	}

	startClock(timeFrmServer: number) {
		if (this.intervalID != null) {
			window.clearTimeout(this.intervalID);
		}
		this.clockTimeInMillis = timeFrmServer;
		this.currentTime = new Date(this.clockTimeInMillis);
		this.updateClock();
	}

	timeZoneDateTime(): Date {
		if (this.clockTimeInMillis && this.getTimeZoneId()) {
			return new Date(
				moment(this.clockTimeInMillis)
					.tz(this.getTimeZoneId())
					.format('M/D/YYYY h:mm:ss a')
			);
		}
		return new Date(
			moment.tz(this.getTimeZoneId()).format('M/D/YYYY h:mm:ss a')
		);
	}

	getTimeForTimeZone() {
		if (this.clockTimeInMillis && this.getTimeZoneId()) {
			return new Date(
				moment(this.clockTimeInMillis)
					.tz(this.getTimeZoneId())
					.format('M/D/YYYY h:mm:ss a')
			);
		}
		return new Date(
			moment.tz(this.getTimeZoneId()).format('M/D/YYYY h:mm:ss a')
		);
	}

	setStrTimeZone(strTz: number) {
		this.strTimeZone = strTz;
	}

	getStrTimeZone() {
		return this.strTimeZone;
	}

	setTimeZoneName(strName: string) {
		this.timezoneName = strName;
	}

	getTimeZoneName() {
		return this.timezoneName;
	}

	getCurrentTime() {
		return this.timeZoneDateTime();
	}

	getCurrentDate() {
		return this.getCurrentTime().getCurrentDate();
	}

	getNextPrevDate(numOfDays: number) {
		const nextDate = this.getCurrentDate();
		if (numOfDays === undefined || numOfDays === 0) {
			return nextDate;
		}
		return new Date(nextDate.setDate(nextDate.getDate() + numOfDays));
	}

	getPreviousDate(numOfDays: number) {
		const nextDate = this.getCurrentDate();
		if (numOfDays === undefined || numOfDays === 0) {
			return nextDate;
		}
		return new Date(nextDate.setDate(nextDate.getDate() - numOfDays));
	}

	getCurrentTimeMinutes() {
		const _dateObj = this.getCurrentTime();
		return _dateObj.getHours() * 60 + _dateObj.getMinutes();
	}

	setTimeZoneId(strName: string) {
		this.fulltimezoneName = strName;
	}

	getTimeZoneId() {
		return this.fulltimezoneName;
	}

	getTimeFromMins(mins: number) {
		return moment.utc().startOf('day').add(mins, 'minutes').format('hh:mm A');
	}
}
